import React, { Fragment } from 'react'
import { Block, Flex } from '../layout'
import { H2, H5, P } from '../text'
import { ImageBlock } from '../image'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBan, faCheckCircle, faInfoCircle } from '@fortawesome/fontawesome-free-solid'
import { Blue } from '../../../constants/colors'

export const Product = props => {
    const { activeId, onClick, product, noImage, z, mobile, dispatch } = props
    const ProductInformation = () => {
        let url = null
        if(product.faqUrl) {
            let faq = product.faqUrl.split(" ").join("")
            url = window.location.origin + faq
        }
        if (product.longDescription) {
	        dispatch({type: "SET_POPUP", payload: {
	            title: <H2>{`${product.displayName} Product Information`}</H2>,
	            info: <Fragment>
	                {product.longDescription && <Fragment>
	                    <H5>Product Description</H5>
	                    <P margin="10px 0 0 0">
	                        {product.longDescription.replace(/<([^>]{1,1024}?)>/gi, "")}
	                    </P>
	                </Fragment>}
	                {product.shippingMessage && <Fragment>
	                    <H5 margin="20px 0 0 0">Shipping Details</H5>
	                    <P margin="10px 0 0 0">
	                        {product.shippingMessage.replace(/<([^>]{1,1024}?)>/gi, "")}
	                    </P>
	                </Fragment>}
	                {product.specification && <Fragment>
	                    <H5 margin="20px 0 0 0">Specifications</H5>
                        <P className="specifications" margin="10px 0 0 0" dangerouslySetInnerHTML={{__html: product?.specification}} />
	                    {/* <P margin="10px 0 0 0">
	                        {product.specification.replace(/(<([^>]+)>)/gi, "")}
	                    </P> */}
	                </Fragment>}
	                {url && <P margin="20px 0 0 0" decoration="underline" color={Blue} cursor="pointer">
	                    <a href={url} rel="noopener noreferrer" target="_blank">Visit the FAQs</a>
	                </P>}
	            </Fragment>
	        }})
        }
    }
    
	return (
        <Block z={z && z} onClick={() => onClick(product ? product : {
                productId: "no",
                productName: "No Thanks",
                noImage: noImage,
                productPriceDescription: {
                    price: 0.00
                }
            })}
            cursor="pointer">
            {((product ? product.productId : "no") === activeId) 
                && <Block width="auto" position="absolute" background="white" radius="15px" top="-15px" right="-15px" z="1">
                    <H5 size="30px" hover="green" color="green">
                        <FontAwesomeIcon icon={faCheckCircle} />
                    </H5>
                </Block>
            }
            <Block outline={((product ? product.productId : "no") === activeId) ? "2px solid green" : "2px solid lightgray"}
                margin="0 0 10px 0">
                {(product && product.imageUrl)
                    ? <ImageBlock width="100%" src={product.imageUrl} />
                    : <Block>
                        <ImageBlock width="100%" src={noImage} />
                        <Flex left="0" top="0" height="100%" background="rgba(255,255,255,.5)" display="flex" position="absolute">
                            <H5 size="38px" hover="#9AA5B3" color="#9AA5B3"><FontAwesomeIcon icon={faBan} /></H5>
                        </Flex>
                    </Block>
                }
            </Block>
            <H5 margin="0 0 5px 0" size="14px">{product ? product.displayName : "No Thanks"}</H5>
            {product && <H5 size="14px">+$ {product.productPriceDescription.price.toFixed(2)}</H5>}
            {product && mobile && <Flex margin="10px 0 0 0" justify="flex-start">
                <P cursor="pointer" onClick={() => ProductInformation()} color={Blue} decoration="underline">
                    Product Information <FontAwesomeIcon icon={faInfoCircle} />
                </P>
                {/* <P cursor="pointer" color={Blue} decoration="underline" margin="0 0 0 10px">
                    Sizing Information <FontAwesomeIcon icon={faInfoCircle} />
                </P> */}
            </Flex>}
        </Block>
	)
}
